import { render, staticRenderFns } from "./ReplyDisplay.vue?vue&type=template&id=48493ec9&scoped=true&"
import script from "./ReplyDisplay.vue?vue&type=script&lang=js&"
export * from "./ReplyDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ReplyDisplay.vue?vue&type=style&index=0&id=48493ec9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48493ec9",
  null
  
)

export default component.exports